export function greeting() {
    const greetingEl = document.querySelector(".contact-modal__greeting");
    if (!greetingEl) return;

    const now = new Date();
    const hour = now.getHours();

    let message = "Hallo";

    if (hour >= 5 && hour < 12) {
        message = "Goedemorgen!";
    } else if (hour >= 12 && hour < 17) {
        message = "Goedemiddag!";
    } else if (hour >= 17 && hour < 23) {
        message = "Goedenavond!";
    } else {
        message = "Goedenacht!";
    }

    greetingEl.textContent = message;
}